import { useMutation } from "@tanstack/react-query";
import { handleGatewayError } from "@src/data/utils/handleGatewayError";
import { FilesApi } from "../files.api";

export type DownloadFilePayload = {
  siren: string;
  millesime: number;
  pathname: string;
  filename: string;
};

export const useDownloadFileMutation = () => {
  return useMutation({
    mutationFn: ({
      siren,
      millesime,
      pathname,
      filename,
    }: DownloadFilePayload) =>
      FilesApi.downloadSingleFile(siren, millesime, pathname, filename, true),
    onError: (error) => {
      handleGatewayError({
        onUnhandled: (err) => {
          console.error(err);
        },
      })(error);
    },
  });
};
